export const tableHeader = [
  'First Name',
  'Last Name',
  'Mobile Number',
  'Email',
  'Status',
  'Action'
]
